import React from 'react';
import { array, string } from 'prop-types';
import { ArrowRight, Plus } from 'lucide-react';

import css from './FAQSection.module.css';

import { IconAdd, IconChat, IconEmail, NamedLink } from '../../../components';
import { FormattedMessage } from '../../../util/reactIntl';

const FAQSection = props => {
  const { sectionId, sectionData, secondaryData } = props;
  const title = (sectionData && sectionData[0]?.title?.content) || '';
  const blocks = (sectionData && sectionData[0]?.blocks) || [];
  const secondary = (secondaryData && secondaryData[0]) || {};

  return (
    <section id={sectionId} className={css.container}>
      <div className={css.wrapper}>
        <div className={css.faqs}>
          <div className={css.headingWrapper}>
            <h2>{title}</h2>
          </div>
          <div className={css.questionsWrapper}>
            {blocks.map(block => (
              <div key={block.blockName} className={css.question}>
                <details>
                  <summary className={css.titleWrapper}>
                    <div className={css.title}>{block.title?.content}</div>
                    <Plus />
                  </summary>

                  <p>{block.text?.content}</p>
                </details>
                <hr />
              </div>
            ))}
            <div className={css.moreWrapper}>
              <button>
                <NamedLink className={css.moreButton} name={'CMSPage'} params={{ pageId: 'faqs' }}>
                  <FormattedMessage id="ProviderLandingPage.faqViewAll" />
                  <ArrowRight />
                </NamedLink>
              </button>
            </div>
          </div>
        </div>
        <div className={css.help}>
          <div className={css.helpHeadingWrapper}>
            <h3>{secondary?.title?.content}</h3>
          </div>
          <div className={css.helpSection}>
            <button className={css.startLiveChat} id="intercom_messenger_launcher">
              <span>{secondary?.description?.content}</span>
              <IconChat stroke="black" />
            </button>
            <a href={`mailto:${secondary?.blocks?.[0].text?.content}`}>
              <span>
                {secondary?.blocks?.[0].title?.content} {secondary?.blocks?.[0].text?.content}
              </span>
              <IconEmail fill="black" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

FAQSection.defaultProps = {
  sectionData: {},
  secondaryData: {},
};

FAQSection.propTypes = {
  sectionId: string.isRequired,
  sectionData: array,
  secondaryData: array,
};

export default FAQSection;
